module.exports = __webpack_public_path__ + "img/homebac.511413b4.png";